import { render, staticRenderFns } from "./TreatmentHx.vue?vue&type=template&id=63c70668"
import script from "./TreatmentHx.vue?vue&type=script&lang=js"
export * from "./TreatmentHx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports